import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-italics",
  "use": "icon-italics-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-italics\">\n<path d=\"M16.5031 0.998535H0.504456V16.9972H16.5031V0.998535Z\" fill=\"white\" fill-opacity=\"0.01\" />\n<path d=\"M6.36015 3.49609H12.3602\" stroke=\"#464646\" stroke-linecap=\"round\" />\n<path d=\"M4.228 14.498H10.228\" stroke=\"#464646\" stroke-linecap=\"round\" />\n<path d=\"M9.08751 3.18799L10.0657 3.3959L7.8444 14.6443L6.86625 14.4363L9.08751 3.18799Z\" fill=\"#464646\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol